import getConfig from 'next/config'
import { TubeProduct } from './enum'
import { useRouter } from '@src/routes'
import { BiTubeProduct } from '../products/BiTube/enum'

const {
  publicRuntimeConfig: { featureFlags },
} = getConfig()

export const useGetProduct = (initialProduct?: string): string => {
  const router = useRouter()
  let product = initialProduct || ''

  if (!product && router.query && router.query.product) {
    product = router.query.product as string
  }

  if (product === TubeProduct.StandardOld && featureFlags.tubesRedesign) {
    return TubeProduct.Standard
  }
  if (
    product === TubeProduct.EasyOligoOld &&
    featureFlags.tubesRedesignRnaEasyOligoPureAndSimple
  ) {
    return TubeProduct.EasyOligo
  }
  if (
    product === TubeProduct.RnaOld &&
    featureFlags.tubesRedesignRnaEasyOligoPureAndSimple
  ) {
    return TubeProduct.Rna
  }
  if (
    product === TubeProduct.PureSimpleOld &&
    featureFlags.tubesRedesignRnaEasyOligoPureAndSimple
  ) {
    return TubeProduct.PureSimple
  }
  if (
    product === TubeProduct.iscalednaOld &&
    featureFlags.tubesRedesignIScaleLongWellRed
  ) {
    return TubeProduct.iscaledna
  }
  if (
    product === TubeProduct.LongOligoOld &&
    featureFlags.tubesRedesignIScaleLongWellRed
  ) {
    return TubeProduct.LongOligo
  }
  if (
    product === TubeProduct.WellredOld &&
    featureFlags.tubesRedesignIScaleLongWellRed
  ) {
    return TubeProduct.Wellred
  }
  if (
    product === TubeProduct.Beacon &&
    featureFlags.tubesRedesignBeaconAndDualLabeled
  ) {
    return TubeProduct.Beacon
  }
  if (
    product === TubeProduct.Probe &&
    featureFlags.tubesRedesignBeaconAndDualLabeled
  ) {
    return TubeProduct.Probe
  }
  if (
    product === BiTubeProduct.LightCyclerOld &&
    featureFlags.biTubesRedesign
  ) {
    return BiTubeProduct.LightCycler
  }
  if (product === BiTubeProduct.FastDuplexOld && featureFlags.biTubesRedesign) {
    return BiTubeProduct.FastDuplex
  }
  if (product === BiTubeProduct.mirnaOld && featureFlags.biTubesRedesign) {
    return BiTubeProduct.mirna
  }

  return product
}
